//Global const file
export const GLOBAL_URL_LOCAL = 'http://localhost:8080/api/';
export const GLOBAL_URL = 'https://smbmapiprod.azurewebsites.net/api/';
//export const GLOBAL_URL = 'http://localhost:8080/api/';